import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'origins',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.ORIGIN_NEW,
  editURL: routes.ORIGIN_EDIT,
  emptyMessage: "You don't have any origins, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Name of VoD Job in process or processed.',
      canOrder: true,
      canFilter: true,
    },
    {
        attributeName: 'type',
        label: 'Type',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        helpText: 'Type of origin',
        canOrder: true,
        canFilter: true,
        exactWidth:'100px',
        filterSelectOptions: [
            { name: 'Type filter...', value: 'no-filter'},
            { name: 'SFTP', value: 'sftp' },
            { name: 'S3', value: 's3' },
            { name: 'GCS', value: 'gcs' },
        ]
      },
    {
      attributeName: 'region',
      label: 'Region',
      helpText: 'URL of the first output file, you can see more output URLs on the VoD detail page.',
      width: '4rem',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'status',
      label: 'Status',
      helpText: 'Status of VoD job.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'log',
      // width: '10rem',
      exactWidth:'200px',
      colors: {
        accessible: 'bg-success',
        unchecked: 'bg-info',
        inaccessible: 'bg-danger'
      },
    },

    {
      attributeName: 'more',
      label: 'More',
      width: '4rem',
      helpText: 'More information about the VoD.',
      type: FormInputTypes.MORE,
      exactWidth:'50px',
    },
  ],
};
